module.exports = __webpack_public_path__ + "images/career-track-5-wide.jpg";